<template>
  <v-row justify="center">
    <v-dialog
      fullscreen
      hide-overlay
      v-if="isDialog"
      v-model="isDialog"
      width="800px"
      @click:outside="closeDialog"
    >
      <v-card color="#f7f3e3">
        <v-card-title>
          <v-toolbar dark color="#2B2118">
            <v-btn icon dark @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{
              feature.id_dataset + ' - "' + feature.dataset_title + '"'
            }}</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row align-content="center" justify="center">
              <v-col cols="12" lg="12">
                <v-row>
                  <v-col cols="12" lg="6">
                    <v-card height="100%">
                      <v-card-title><h5>General Information:</h5></v-card-title>
                      <v-card-text>
                        <p>{{ "ID Dataset: " + feature.id_dataset }}</p>
                        <p>
                          {{ "Site Name: " + feature.geo.siteName }}
                        </p>
                        <p>{{ "Author(s): " + feature.investigators }}</p>
                        <p>
                          {{ "Main Archive Type: "
                          }}<v-chip>{{ feature.archiveType }}</v-chip>
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" lg="6">
                    <v-card height="100%">
                      <v-card-title><h5>Site Information:</h5></v-card-title>
                      <v-card-text>
                        <p>
                          {{
                            "Country / Region: " +
                            feature.geo.properties.location
                          }}
                        </p>

                        <p>
                          {{
                            "Latitude (average): " +
                            feature.latitude +
                            "° N"
                          }}
                        </p>
                        <p>
                          {{
                            "Longitude (average): " +
                            feature.longitude +

                            "° E"
                          }}
                        </p>
                        <p>
                          {{
                            feature.altitude
                              ? "Altitude (average): " +
                                feature.altitude +

                                " m"
                              : "Altitude: not available."
                          }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="12">
                    <v-card height="100%">
                      <v-card-title><h5>Publication(s):</h5></v-card-title>
                      <v-card-text>
                        <v-data-table :items="feature.pub" :headers="headers"
                          ><template v-slot:item.author="{ item }">
                            <span>{{
                              item.author.map((a) => a.name).join("; ")
                            }}</span>
                          </template>
                          <template v-slot:item.identifier="{ item }">
                            <a :href="item.identifier.url">{{
                              item.identifier.id
                            }}</a>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" lg="12">
                    <v-card height="100%">
                      <v-card-title
                        ><h5>File(s):</h5>
                        <v-spacer></v-spacer>
                        <v-btn
                          dark
                          color="#2B2118"
                          @click="downloadItem(feature)"
                          ><v-icon left>mdi-download</v-icon>Download
                          .LPD</v-btn
                        ></v-card-title
                      >
                      <v-card-text>
                        <v-data-table
                          :items="filesList"
                          :headers="headers_files"
                        >
                          <template v-slot:item.is_apd="{ item }">
                            <span>{{
                              item.paleodata_title
                                ? item.paleodata_title
                                : item.chronodata_title
                                ? item.chronodata_title
                                : ""
                            }}</span>
                          </template>
                          <template v-slot:item.filetype="{ item }">
                            <v-chip
                              dark
                              :color="
                                item.filetype === 'samples' ? 'warning' : 'blue'
                              "
                              >{{
                                item.filetype === "samples"
                                  ? "Samples"
                                  : "Pollen counts"
                              }}</v-chip
                            >
                          </template>
                          <template v-slot:item.created_at="{ item }">
                            <span>{{
                              new Date(item.created_at).toDateString()
                            }}</span>
                          </template>
                          <template v-slot:item.updated_at="{ item }">
                            <span>{{
                              new Date(item.updated_at).toDateString()
                            }}</span>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon @click="loadCsvData(item)">mdi-eye</v-icon>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" xl="12"
                    ><div id="datatable">
                      <v-card
                      ><v-card-title
                        >CSV data
                        {{
                          csv_title ? ' - "' + csv_title + '"' : ""
                        }}</v-card-title
                      >
                      <v-card-text
                        ><hot-table
                          v-if="csv_data"
                          ref="hotTableComponent"
                          class="hottable"
                          :settings="getHotSettings"
                        ></hot-table>
                        <span v-if="!csv_data"
                          >Select a file to show spreadsheet data.</span
                        >
                      </v-card-text></v-card
                    >
                    </div>
                    
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- <v-card-actions>
          <v-btn disabled> Download<v-icon right>mdi-download</v-icon> </v-btn>
          <v-spacer></v-spacer>
          <v-btn dark @click="closeDialog">
            Close<v-icon right>mdi-close</v-icon>
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
var urljoin = require("url-join");
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { HotTable } from "@handsontable/vue";
/* import Handsontable from "handsontable"; */
const HOST_ROOT = process.env.VUE_APP_ROOT_API;

export default {
  props: ["dialog", "feature"],
  components: {
    HotTable,
  },
  data() {
    return {
      csv_data: null,
      csv_header: null,
      csv_title: null,
      hotSettings: {
        data: null,
        readOnly: true,
        colHeaders: true,
        height: "1000",
        width: "auto",
        stretchH: "all",
        licenseKey: "non-commercial-and-evaluation",
      },
      filesList: [],
      headers_files: [
        {
          text: "File Type",
          align: "start",
          value: "filetype",
        },
        {
          text: "Title",
          align: "start",
          value: "is_apd",
        },

        {
          text: "Created",
          align: "right",
          value: "created_at",
        },
        {
          text: "Updated",
          align: "right",
          value: "updated_at",
        },
        {
          text: "View File",
          value: "actions",
          align: "right",
          sortable: false,
        },
      ],
      headers: [
        {
          text: "Author(s)",
          align: "start",
          value: "author",
        },
        {
          text: "Year",
          align: "start",
          value: "year",
        },

        {
          text: "Title",
          value: "title",
        },
        {
          text: "Issue",
          value: "issue",
        },
        {
          text: "Vol.",
          value: "volume",
        },
        {
          text: "Ed.",
          value: "edition",
        },
        {
          text: "Journal",
          value: "journal",
        },
        {
          text: "Pages",
          value: "pages",
        },
        {
          text: "DOI",
          value: "identifier",
        },
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
    };
  },
  name: "PollenModerneDetailDialog",

  methods: {
    async loadCsvData(item) {
      document.getElementById('datatable').scrollIntoView();
      let url = "";
      if (item.id_paleodata) {
        url = urljoin(
          HOST_ROOT,
          `api/modern-paleodata-complete/${item.id_paleodata}/`
        );
        this.csv_title = item.paleodata_title;
      } else {
        url = urljoin(
          HOST_ROOT,
          `api/modern-chronodata-complete/${item.id_chronodata}/`
        );
        this.csv_title = item.chronodata_title;
      }

      const response = await axios.get(url);
      var csvData = response.data.csv_data;
      var header = response.data.columns.map(
        (c) => c.variableName + " [" + c.units + "]"
      );
      if (
        this.checkArrays(
          csvData[0],
          response.data.columns.map((c) => c.variableName)
        )
      ) {
        this.csv_data = csvData.slice(1);
      } else {
        console.log(csvData[0]);
        console.log(response.data.columns.map((c) => c.variableName));
        this.csv_data = csvData;
      }

      /* console.log(csvData); */
      this.csv_header = header;
      this.$refs.hotTableComponent.hotInstance.updateSettings({
        data: this.csv_data,
        colHeaders: this.csv_header,
      });
      
    },
    closeDialog() {
      this.$emit("update:dialog", !this.dialog);
    },
    async downloadItem(item) {
      try {
        /* Initializing archive */
        var zip = new JSZip();
        var bag = zip.folder("bag");
        var lipd = bag.folder("data");

        /* Downloading metadata */
        var url_metadata = urljoin(
          HOST_ROOT,
          `api/modern-dataset/${item.id_dataset}/`
        );
        const response = await axios.get(url_metadata);
        lipd.file(
          "metadata.jsonld",
          JSON.stringify(response.data.json_metadata)
        );

        /* Downloading related paleodata files */
        var url_paleodata = urljoin(
          HOST_ROOT,
          `api/modern-paleodata?id_dataset=${item.id_dataset}`
        );
        const response3 = await axios.get(url_paleodata);
        let paleoFiles = response3.data;
        for (var p of paleoFiles) {
          /* console.log(JSON.stringify(p)) */
          const p_file = await axios.get(
            process.env.NODE_ENV === "production"
              ? p.paleodata_file.replace("http", "https")
              : p.paleodata_file
          );
          lipd.file(p.paleodata_title + ".csv", p_file.data);
        }

        /* Generating .lpd archive */
        zip.generateAsync({ type: "blob" }).then(function (content) {
          // see FileSaver.js
          saveAs(content, item.dataset_title + ".lpd");
        });
      } catch (error) {
        console.log(error);
      }
    },
    checkArrays(array1, array2) {
      var is_same =
        array1.length == array2.length &&
        array1.every(function (element, index) {
          return element === array2[index];
        });
      return is_same;
    },
    async getFilesList(item) {
      try {
        /* Downloading related paleodata files */
        var url_paleodata = urljoin(
          HOST_ROOT,
          `api/modern-paleodata?id_dataset=${item.id_dataset}`
        );
        const response3 = await axios.get(url_paleodata);
        let paleoFiles = response3.data;

        this.filesList = paleoFiles;
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {},
  watch: {
    isDialog(newstate, oldstate) {
      if (newstate) {
        this.getFilesList(this.feature);
      } else {
        this.csv_header = null;
        this.csv_data = null;
        this.csv_title = null;
        this.$refs.hotTableComponent.hotInstance.updateSettings(
          this.getHotSettings()
        );
        console.log(oldstate);
      }
    },
  },
  computed: {
    isDialog() {
      return this.dialog;
    },
    getHotSettings() {
      return {
        data: this.csv_data,
        readOnly: true,
        colHeaders: this.csv_header,
        stretchH: "all",
        height: "500",
        width: "auto",
        licenseKey: "non-commercial-and-evaluation",
      };
    },
  },
};
</script>

<style >
@import "../../../node_modules/handsontable/dist/handsontable.full.css";
</style>